import { Translate } from "next-translate";
import { TSelectOption } from "~/components/atoms/form/SelectField";
import { errorWithoutThrowInProduction } from "~/lib/logging/logHelper";
import {
  DOMAIN_PRICE_RANK_DEV,
  DOMAIN_PRICE_RANK_DEV_VN,
  PROJECT_ID_PRICE_RANK_DEV,
} from "~/models/project";

export enum LocaleEnum {
  en = "en",
  ja = "ja",
  vn = "vn",
}

export function generateLocaleOptions({
  locales,
  t,
}: {
  locales: string[];
  t: Translate;
}): TSelectOption[] {
  if (locales?.length < 1) {
    return [];
  }

  const options = locales.map((l) => ({ text: getLocaleText(l, t), value: l }));

  return options;
}

function getLocaleText(locale: string, t: Translate) {
  switch (locale) {
    case LocaleEnum.en:
      return t("common:locale.name.en");
    case LocaleEnum.ja:
      return t("common:locale.name.ja");
    case LocaleEnum.vn:
      return t("common:locale.name.vn");
    default:
      errorWithoutThrowInProduction({
        errorInfo: { locale },
        errorMessage: "Unsupported locale",
      });
      return locale;
  }
}

export function getLocaleBaseUrl({
  locale,
  projectId,
}: {
  locale: string;
  projectId: string;
}): string | undefined {
  if (projectId !== PROJECT_ID_PRICE_RANK_DEV) {
    return undefined;
  }

  switch (locale) {
    case LocaleEnum.en:
      return `https://${DOMAIN_PRICE_RANK_DEV}`;
    case LocaleEnum.ja:
      return `https://${DOMAIN_PRICE_RANK_DEV}/ja`;
    case LocaleEnum.vn:
      return `https://${DOMAIN_PRICE_RANK_DEV_VN}`;
    default:
      return undefined;
  }
}

export function getHrefLangByLocale({
  locale,
}: {
  locale: string;
}): string | undefined {
  switch (locale) {
    case LocaleEnum.en:
      return "en";
    case LocaleEnum.ja:
      return "ja";
    case LocaleEnum.vn:
      return "vi";
    default:
      return undefined;
  }
}
